import type { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/apps/admin-console/router/RouteName";
import {
	navigationGuardForAdmin,
	navigationGuardLoggedIn,
	navigationGuardForDashboardUsers,
	navigationGuardForModuleDashboard,
	navigationGuardForBillingModule,
	navigationGuardForClerkModule,
} from "@/apps/admin-console/helpers/navigationGuards";
import { adminConsoleTranslationGuard } from "@/router/translationGuards";

// Lazy-loaded view components for code splitting
const AdminLoginView = () =>
	import("@/apps/admin-console/views/AdminLoginView.vue");
const DashboardView = () =>
	import("@/apps/admin-console/views/DashboardView.vue");
const ReportsView = () => import("@/apps/admin-console/views/ReportsView.vue");
const ClerksView = () => import("@/apps/admin-console/views/ClerksView.vue");
const MerchantsListView = () =>
	import("@/apps/admin-console/views/MerchantsListView.vue");
const PartnerApiView = () =>
	import("@/apps/admin-console/views/PartnerApiView.vue");
const SettingsView = () =>
	import("@/apps/admin-console/views/SettingsView.vue");
const CatalogAndPricingView = () =>
	import("@/apps/admin-console/views/CatalogAndPricingView.vue");
const BillingPortalView = () =>
	import("@/apps/admin-console/views/BillingPortalView.vue");
const CreateMerchantView = () =>
	import("@/apps/admin-console/views/CreateMerchantView.vue");
const HomeView = () => import("@/apps/admin-console/views/HomeView.vue");

const routes: Array<RouteRecordRaw> = [
	{
		path: "/admin-console/login",
		name: RouteName.Login,
		component: AdminLoginView,
		meta: { title: "Login" },
		beforeEnter: [
			navigationGuardForAdmin,
			navigationGuardForDashboardUsers,
			adminConsoleTranslationGuard,
		],
	},
	{
		path: "/admin-console",
		name: RouteName.Home,
		component: HomeView,
		meta: { title: "Home" },
		beforeEnter: [navigationGuardLoggedIn, adminConsoleTranslationGuard],
	},
	{
		path: "/admin-console/reports",
		name: RouteName.Reports,
		component: ReportsView,
		meta: { title: "Reports" },
		beforeEnter: [navigationGuardLoggedIn, adminConsoleTranslationGuard],
	},
	{
		path: "/admin-console/clerks",
		name: RouteName.Clerks,
		component: ClerksView,
		meta: { title: "Clerks" },
		beforeEnter: [
			navigationGuardLoggedIn,
			navigationGuardForClerkModule,
			adminConsoleTranslationGuard,
		],
	},
	{
		path: "/admin-console/partnerapi",
		name: RouteName.PartnerApi,
		component: PartnerApiView,
		meta: { title: "API" },
		beforeEnter: [navigationGuardLoggedIn, adminConsoleTranslationGuard],
	},
	{
		path: "/admin-console/settings",
		name: RouteName.Settings,
		component: SettingsView,
		meta: { title: "Settings" },
		beforeEnter: [navigationGuardLoggedIn, adminConsoleTranslationGuard],
	},
	{
		path: "/admin-console/catalog-and-pricing",
		name: RouteName.CatalogAndPricing,
		component: CatalogAndPricingView,
		beforeEnter: [navigationGuardLoggedIn, adminConsoleTranslationGuard],
	},
	{
		path: "/admin-console/merchants",
		name: RouteName.Merchants,
		component: MerchantsListView,
		beforeEnter: [navigationGuardLoggedIn, adminConsoleTranslationGuard],
	},
	{
		path: "/admin-console/billing-portal",
		name: RouteName.BillingPortal,
		component: BillingPortalView,
		beforeEnter: [
			navigationGuardLoggedIn,
			navigationGuardForBillingModule,
			adminConsoleTranslationGuard,
		],
	},
	{
		path: "/admin-console/create-merchant",
		name: RouteName.CreateMerchant,
		component: CreateMerchantView,
		beforeEnter: [navigationGuardLoggedIn, adminConsoleTranslationGuard],
	},
	{
		path: "/admin-console/dashboard",
		name: RouteName.Dashboard,
		component: DashboardView,
		beforeEnter: [
			navigationGuardLoggedIn,
			navigationGuardForModuleDashboard,
			adminConsoleTranslationGuard,
		],
	},
];

export default routes;
